document.addEventListener('DOMContentLoaded', function () {
  // غيّر الرابط لو عايز تودّي لصفحة تانية
  var DISCOUNT_URL = '/collections/all?discount=BL5';

  // راقب ظهور رسالة نجاح للاشتراك في النيوزليتر ثم حوّل
  var observer = new MutationObserver(function () {
    var successEl = document.querySelector(
      '.newsletter__success, .popup__success, .signup-success, .form__message--success, .klaviyo_subscribe_success'
    );
    if (successEl && successEl.offsetParent !== null) {
      window.location.href = DISCOUNT_URL;
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // لو الثيم يطلق حدث نجاح
  document.addEventListener('shopify:newsletter:success', function () {
    window.location.href = DISCOUNT_URL;
  });

  // فFallback: لو أضيف بارامتر نجاح باللينك
  var q = new URLSearchParams(window.location.search);
  if (q.get('newsletter') === 'success' || q.get('customer_posted') === 'true') {
    window.location.replace(DISCOUNT_URL);
  }
});
